import React from "react";
import Page from "../templates/empower/wellbeing/wellbeing-page";

export default function home() {
  return (
    <div>
      <Page />
    </div>
  );
}
